import { Coords, Viewport } from '../../../../../swagger-api';

export interface GeocoderResponse {
  address_components: google.maps.GeocoderAddressComponent[];
  location: google.maps.LatLng;
  viewport?: google.maps.LatLngBounds;
  street?: string;
}

export interface PreparedLocation {
  address_components: google.maps.GeocoderAddressComponent[];
  street: string;
  center: Coords;
  viewport: Viewport;
}

export function parseGeocoderResponse(geocoderResponse: GeocoderResponse): PreparedLocation {
  let viewport: Viewport;
  if (geocoderResponse.viewport) {
    const northeast: google.maps.LatLng = geocoderResponse.viewport.getNorthEast();
    const southwest: google.maps.LatLng = geocoderResponse.viewport.getSouthWest();
    viewport = {
      northeast: {
        lat: northeast.lat(),
        lon: northeast.lng(),
      },
      southwest: {
        lat: southwest.lat(),
        lon: southwest.lng(),
      },
    };
  }
  return {
    address_components: geocoderResponse.address_components,
    street: geocoderResponse.street,
    center: {
      lat: geocoderResponse.location.lat(),
      lon: geocoderResponse.location.lng(),
    },
    viewport: viewport,
  };
}
